import React, { useEffect, useState } from "react";
import "../../../assets/css/style.css";
import "./header.css";
import logoImg from "../../../assets/logos/logo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import LoginForm from "../../LoginFormModal/LoginForm";
import RegistrationForm from "../../RegistrationFormModal/RegistrationForm";

export default function Header({ image }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegistration, setShowRegistration] = useState(false);
  const [pageValue, setPageValue] = useState("");
  const token = localStorage.getItem("token");
  const ProfileImage = localStorage.getItem("userProfile");
  const isBlogPage = [
    "/blog",
    "/blogDetail",
    "/viewallblog",
    "/blogpost",
    "/articlepost",
    "/myblog",
    "/blogform",
    "/newsletter",
    "/viewallarticle",
  ].some((path) => location.pathname.startsWith(path));

  useEffect(() => {
    if (isBlogPage && !token) {
      setPageValue("Blog");
    } else if (isBlogPage && token) {
      setPageValue("");
    }
  }, [isBlogPage, token, location]);

  const onNavClick = (pathname) => {
    navigate(pathname);
    setMobileMenuOpen(false); // Close menu on nav
  };
  const handleGetInTouchClick = () => {
    navigate("/getInTouch");
  };
  const goToHome = () => {
    navigate("/home");
  };
  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="upper_header">
        <div className="container">
          <div className="socials_outer">
            <div className="social_inner">
              <div className="socials_box">
                <img src={require("../../../assets/icons/gmail.png")} alt="" />
                <p>contact@techfeature.in</p>
              </div>
              <div className="socials_box">
                <img src={require("../../../assets/icons/mobile.png")} alt="" />
                <p>+91-8588889893</p>
              </div>
              <div className="follow_us">
                <a
                  href="https://www.linkedin.com/company/techfeatures/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../../../assets/icons/linkedin.png")}
                    alt="LinkedIn"
                  />
                </a>
                <a
                  href="https://wa.me/+918588889893"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../../../assets/icons/whatsapp.png")}
                    alt="WhatsApp"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header>
        <div className="lower_header">
          <div className="container">
            <nav className="main_nav">
              <div className="logo" onClick={goToHome}>
                <img src={logoImg} alt="Logo" />
              </div>

              <div className="navlinks desktop_only">
                <ul className="">
                  <li
                    className={isActive("/home") ? "active" : ""}
                    onClick={() => {
                      onNavClick("/home");
                      setPageValue("");
                    }}
                  >
                    Home
                  </li>
                  <li
                    className={isActive("/about") ? "active" : ""}
                    onClick={() => {
                      onNavClick("/about");
                      setPageValue("");
                    }}
                  >
                    About us
                  </li>
                  <li
                    className={isActive("/services") ? "active" : ""}
                    onClick={() => {
                      onNavClick("/services");
                      setPageValue("");
                    }}
                  >
                    Services
                  </li>
                  <li
                    className={isActive("/portfolio") ? "active" : ""}
                    onClick={() => {
                      onNavClick("/portfolio");
                      setPageValue("");
                    }}
                  >
                    Portfolio
                  </li>
                  {/* <li
                    className={isActive("/hiredev") ? "active" : ""}
                    onClick={() => {
                      onNavClick("/hiredev");
                      setPageValue("");
                    }}
                  >
                    Hire Developer
                  </li> */}
                  <li
                    className={isActive("/contact") ? "active" : ""}
                    onClick={() => {
                      onNavClick("/contact");
                      setPageValue("");
                    }}
                  >
                    Contact Us
                  </li>
                  {/* <li
                    className={isActive("/blog") ? "active" : ""}
                    onClick={() => {
                      onNavClick("/blog");
                    }}
                  >
                    Blog
                  </li> */}
                </ul>
              </div>

              <div className="right_section">
                <button
                  className="secondary_btn mr-10"
                  onClick={handleGetInTouchClick}
                >
                  Get In Touch
                </button>
                {/* {pageValue === "Blog" && (
                  <ul className="signup_login_menu">
                    <li onClick={() => setShowLogin(true)}>Login</li>
                    <li>/</li>
                    <li onClick={() => setShowRegistration(true)}>Register</li>
                  </ul>
                )}
                <div className="p-relative">
                  {ProfileImage && (
                    <img
                      src={
                        image ||
                        require("../../../assets/icons/user-profile-icon.png")
                      }
                      alt="User Profile"
                      className="menu_user_profile_icon"
                      onClick={() => navigate("/userProfile")}
                    />
                  )}
                </div> */}
                <img
                  className="mobile_only hamburger_icon"
                  onClick={() => setMobileMenuOpen(true)}
                  src={require("../../../assets/icons/menu (1).png")}
                  alt=""
                />
              </div>
            </nav>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="mobile_menu_overlay">
          <div className="mobile_menu_header">
            <img
              src={logoImg}
              alt="Logo"
              className="overlay_logo"
              onClick={goToHome}
            />
            <i
              className="bi bi-x-lg close_icon"
              onClick={() => setMobileMenuOpen(false)}
            ></i>
          </div>
          <ul className="overlay_links">
            <li onClick={() => onNavClick("/home")}>Home</li>
            <li onClick={() => onNavClick("/about")}>About us</li>
            <li onClick={() => onNavClick("/services")}>Services</li>
            <li onClick={() => onNavClick("/portfolio")}>Portfolio</li>
            {/* <li onClick={() => onNavClick("/hiredev")}>Hire Developer</li> */}
            <li onClick={() => onNavClick("/contact")}>Contact Us</li>
            {/* <li onClick={() => onNavClick("/blog")}>Blog</li> */}
          </ul>
        </div>
      )}
      {showLogin && (
        <LoginForm
          onClose={() => setShowLogin(false)}
          showRegister={() => {
            setShowRegistration(true);
            setShowLogin(false);
          }}
        />
      )}
      {showRegistration && (
        <RegistrationForm onClose={() => setShowRegistration(false)} />
      )}
    </>
  );
}
